import styled, { css } from 'styled-components';
import { breakpoint, fontSettings } from '../../../styles';

export const CustomersSubscriptionPopup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const CustomersSubscriptionPopupTitle = styled.div`
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_28, theme.FONT)};
  color: ${({ theme }): string => theme.COLOR.TEXT_DARK_COLOR};
  font-weight: 700;
  margin-top: 32px;
`;

export const CustomersSubscriptionPopupSubtitle = styled.div`
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_17, theme.FONT)};
  color: ${({ theme }): string => theme.COLOR.TEXT_LIGHT_COLOR};
  font-weight: 400;
  margin-top: 8px;

  a,
  span {
    display: inline-block;
    cursor: pointer;
    color: ${({ theme }): string => theme.COLOR.PRIMARY['500']};

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const CustomersSubscriptionPopupControls = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 16px;
  width: 100%;

  ${breakpoint(
    'smallDown',
    css`
      flex-wrap: wrap;
    `
  )};
`;
